export enum GLYPH_FONTS {
  ICON = 'onxIcon',
  CIRCLE = 'onxCircle',
  ROUNDED = 'onxRounded',
  SELECTED_ROUNDED = 'onxSelectedStateRounded',
  SELECTED_CIRCLE = 'onxSelectedStateCircle',
}

export const GLYPH_ICON_TYPES = {
  ICON: 'icon',
  CIRCLE: 'circle',
  ROUNDED: 'rounded',
  SELECTED_CIRCLE: 'selectedstate_circle',
  SELECTED_ROUNDED: 'selectedstate_rounded',
}
